<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/quality/sampling/plan/details/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item class="noborder" :label="$t('chouyangfanganbianma	')">
            <el-input disabled v-model="$attrs.aql.code"></el-input>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('chouyangfanganmingcheng	')">
            <el-input disabled v-model="$attrs.aql.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('yangedu')">
            <el-select v-model="yt.conditions.level">
              <el-option :label="$t('zhengchang')" :value="1"></el-option>
              <el-option :label="$t('fangkuan')" :value="2"></el-option>
              <el-option :label="$t('jiayan')" :value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('AQL')">
            <el-input v-model="yt.conditions.aql"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear({ samplingPlanId: $attrs.aql.id })">{{ $t('chongzhi') }}
            </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button size="mini" @click="yt.showEditDialog('xinzeng', null, 'w1')" type="primary">
          {{ $t('xinzeng') }}
        </el-button>
        <el-button size="mini" @click="show = !show" plain>
          {{ $t('daoru') }}
        </el-button>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
      <!-- 严格度 -->
      <template #yangedu='scope'>
        <span v-if="scope.row.level == 1">{{ $t('zhengchang') }}</span>
        <span v-if="scope.row.level == 2">{{ $t('fangkuan') }}</span>
        <span v-if="scope.row.level == 3">{{ $t('jiayan') }}</span>
      </template>
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('bianji', scope.row)">{{ $t('bianji') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" class="font-color-danger" @click="yt.remove(scope.row, '/web/quality/sampling/plan/details/delete')">
              {{ $t('shanchu') }}
            </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增 -->
      <template v-if="yt.editObj.action == 'xinzeng'">
        <div class="dialog-scroller">
          <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
            <el-form-item :label="$t('yangedu')" required>
              <el-select v-model="yt.editObj.level">
                <el-option :label="$t('zhengchang')" :value="1"></el-option>
                <el-option :label="$t('fangkuan')" :value="2"></el-option>
                <el-option :label="$t('jiayan')" :value="3"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('AQL')" required>
              <el-input v-model="yt.editObj.aql"></el-input>
            </el-form-item>
            <el-form-item :label="$t('piliangxiaxian')" required>
              <el-input v-model="yt.editObj.numMin"></el-input>
            </el-form-item>
            <el-form-item :label="$t('piliangshangxian')" required>
              <el-input v-model="yt.editObj.numMax"></el-input>
            </el-form-item>
            <el-form-item :label="$t('yangbenshu')" required>
              <el-input v-model="yt.editObj.num"></el-input>
            </el-form-item>
            <el-form-item :label="$t('AC')" required>
              <el-input v-model="yt.editObj.ac"></el-input>
            </el-form-item>
            <el-form-item :label="$t('RE')" required>
              <el-input v-model="yt.editObj.re"></el-input>
            </el-form-item>
          </el-form>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="yt.req('POST', '/web/quality/sampling/plan/details/create', beforeAdd)" type="primary" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '抽样方案-新增AQL' } }">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <!-- 编辑 -->
      <template v-if="yt.editObj.action == 'bianji'">
        <div class="dialog-scroller">
          <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
            <el-form-item :label="$t('yangedu')" required>
              <el-select v-model="yt.editObj.level">
                <el-option :label="$t('zhengchang')" :value="1"></el-option>
                <el-option :label="$t('fangkuan')" :value="2"></el-option>
                <el-option :label="$t('jiayan')" :value="3"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('AQL')" required>
              <el-input v-model="yt.editObj.aql"></el-input>
            </el-form-item>
            <el-form-item :label="$t('piliangxiaxian')" required>
              <el-input v-model="yt.editObj.numMin"></el-input>
            </el-form-item>
            <el-form-item :label="$t('piliangshangxian')" required>
              <el-input v-model="yt.editObj.numMax"></el-input>
            </el-form-item>
            <el-form-item :label="$t('yangbenshu')" required>
              <el-input v-model="yt.editObj.num"></el-input>
            </el-form-item>
            <el-form-item :label="$t('AC')" required>
              <el-input v-model="yt.editObj.ac"></el-input>
            </el-form-item>
            <el-form-item :label="$t('RE')" required>
              <el-input v-model="yt.editObj.re"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="yt.req('POST', '/web/quality/sampling/plan/details/update')" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
    </el-dialog>
    <!-- 导入excel -->
    <import-excel :show.sync="show" :listId="$attrs.aql.id" />
  </div>
</template>
<script type="text/javascript">
import importExcel from './import_excel'
export default {
  name: 'web_quality_management_sampling_plan_list',
  components: {
    importExcel
  },
  data() {
    return {
      show: false,
      columns: [{
        label: 'yangedu',
        prop: 'level',
        type: 'slot'
      }, {
        label: 'AQL',
        prop: 'aql',
        width: 130,
      }, {
        label: 'piliangxiaxian',
        prop: 'numMin',
        width: 180,
      }, {
        label: 'piliangshangxian',
        prop: 'numMax',
        width: 130,
        // format: 'yyyy-MM-dd:hh:mm:ss'
      }, {
        label: 'yangbenshu',
        prop: 'num',
        width: 130,
      }, {
        label: 'AC',
        prop: 'ac',
        width: 130,
      }, {
        label: 'RE',
        prop: 're',
        width: 130,
      },
      {
        label: 'caozuo',
        type: 'slot',
        width: 150,
        fixed: 'right'
      }
      ]
    };
  },
  mounted() {
    // console.log('kfwesdfj',this.yt.editObj)
  },
  created() {
    setTimeout(() => {
      this.yt.conditions = {
        samplingPlanId: this.$attrs.aql.id,
      }
      this.yt.get(1);
      this.utils.event_hub.$on('QUALITY_MANAGEMENT_REFRESH', () => {
        this.yt.get(1);
      })
    }, 300)
  },

  methods: {
    beforeAdd(params, url) {
      params.samplingPlanId = this.$attrs.aql.id
      return params
    }
  }
};
</script>
